<template>
  <div id="#add-employer-form">
    <section class="mt-4" v-if="step === 1">
      <!--       <div class="row">
        <div class="col-12 col-lg-6 ml-auto mr-auto mb-4 mt-4">
          <div class="multisteps-form__progress">
            <button class="multisteps-form__progress-btn js-active" type="button" title="User Info">
              Step 1
            </button>
            <button class="multisteps-form__progress-btn" type="button" title="Address">
              Step 2
            </button>
          </div>
        </div>
      </div> -->

      <div class="row justify-content-center">
        <div class="col-md-11">
          <!-- error msg -->
          <!-- <Message v-show="errorMessage" class="mt-2" type="error-alert">
            <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
          </Message>-->

          <form id="add-job-emp-modal" @submit.prevent="addJob">
            <fieldset :disabled="isLoading">
              <div class="form-group m-label-left isWidth required-fixed-right">
                <input
                  type="text"
                  id="name"
                  v-model.trim.lazy="$v.selectedFields.name.$model"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedFields.name.$error,
                    'is-valid': !$v.selectedFields.name.$invalid,
                  }"
                  @change="stepValidator"
                  required
                />
                <label for="name">Name</label>
              </div>

              <div class="form-group m-label-left isWidth">
                <input
                  type="text"
                  id="og-number"
                  v-model="selectedFields.orgo"
                  class="form-control"
                  required
                />
                <label for="og-number">Registration number</label>
              </div>
              <div class="form-group m-label-left isWidth required-fixed-right">
                <input
                  type="text"
                  id="street-address"
                  v-model.trim.lazy="$v.selectedFields.street.$model"
                  class="form-control"
                  :class="{
                    'is-invalid': $v.selectedFields.street.$error,
                    'is-valid': !$v.selectedFields.street.$invalid,
                  }"
                  @change="stepValidator"
                  required
                />
                <label id="street-address">Street address</label>
              </div>
              <div class="row">
                <div class="form-group m-label required-fixed-postal-code col-md-4">
                  <input
                    type="number"
                    id="postal-code"
                    v-model.trim.lazy="$v.selectedFields.postal.$model"
                    class="form-control"
                    :class="{
                      'is-invalid': $v.selectedFields.postal.$error,
                      'is-valid': !$v.selectedFields.postal.$invalid,
                    }"
                    @change="stepValidator"
                    required
                    autocomplete
                  />
                  <label for="postal-code">Postal code</label>
                </div>

                <div class="form-group filter-item m-label col-md-8 required-fixed-drop">
                  <v-select
                    v-model.trim.lazy="$v.selectedCity.$model"
                    label="name"
                    :options="getCitiesListByCountry"
                    :reduce="city => city"
                    id="city"
                    :clearable="true"
                  >
                    <template v-slot:no-options>
                      <div style="opacity: 0.5">Please select a country first</div>
                    </template>
                  </v-select>
                  <label for="city">City</label>
                </div>
              </div>
              <div class="form-group filter-item m-label-left required-fixed-right-even">
                <v-select
                  v-model.trim.lazy="$v.selectedCountry.$model"
                  @input="fetchCitiesByCountryId($event)"
                  @change="changeDefaultCountry"
                  :options="getAllCountries"
                  label="name"
                  id="Country"
                  :reduce="country => country"
                  :clearable="true"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">Sorry, no matching country</div>
                  </template>
                </v-select>
                <label for="country">Country</label>
              </div>

              <div class="form-group m-label-left isWidth">
                <input
                  type="url"
                  id="website"
                  v-model="selectedFields.website"
                  class="form-control"
                  required
                />
                <label for="website">Website</label>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </section>

    <section class="mt-4" v-if="step === 2">
      <!--       <div class="row">
        <div class="col-12 col-lg-6 ml-auto mr-auto mb-5 mt-4">
          <div class="multisteps-form__progress">
            <button class="multisteps-form__progress-btn" type="button" title="Step 1">
              Step 1
            </button>
            <button class="multisteps-form__progress-btn js-active" type="button" title="Address">
              Step 2
            </button>
          </div>
        </div>
      </div> -->

      <div class="row justify-content-center">
        <div class="col-md-11">
          <!-- VALIDATION MESSAGES -->
          <Message v-show="errorMessage" class="mt-2 text-center" type="error-alert">
            <p slot="alert-message" class="mb-0" style="font-weight: 700">{{ errorMessage }}</p>
          </Message>

          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              type="text"
              id="first-name"
              v-model.trim.lazy="$v.selectedFields.firstName.$model"
              class="form-control"
              :class="{
                'is-invalid': $v.selectedFields.firstName.$error,
                'is-valid': !$v.selectedFields.firstName.$invalid,
              }"
              @change="stepValidator"
              :disabled="isLoading"
              required
            />
            <label for="first-name">First name</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              type="text"
              id="last-name"
              v-model.trim.lazy="$v.selectedFields.lastName.$model"
              class="form-control"
              :class="{
                'is-invalid': $v.selectedFields.lastName.$error,
                'is-valid': !$v.selectedFields.lastName.$invalid,
              }"
              @change="stepValidator"
              :disabled="isLoading"
              required
            />
            <label for="last-name">Last name</label>
          </div>

          <div class="form-group m-label-left isWidth has-floating-label">
            <input
              type="text"
              id="title"
              v-model="selectedFields.title"
              class="form-control"
              :disabled="isLoading"
              required
            />
            <label for="title">Title</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              type="email"
              id="email"
              class="form-control"
              :class="{
                'is-invalid': $v.selectedEmail.$error,
                'is-valid': !$v.selectedEmail.$invalid,
              }"
              v-model="selectedEmail"
              @click="
                checkEmailExist($event);
                stepValidator();
              "
              :disabled="isLoading"
              required
            />
            <label for="email">Email</label>
          </div>

          <div class="row">
            <div class="form-group filter-item m-label required-fixed-right-even col-md-5 no-hor">
              <v-select
                @input="addCountryCode(selectedFields.countryCode)"
                id="c-code"
                placeholder="Country Code"
                v-model="selectedFields.countryCode"
                :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                :clearable="false"
                label="name"
              >
                <!-- <template v-slot:option="option">
                  {{ option.label }}
                </template> -->
              </v-select>
              <label for="c-code">Country code</label>
            </div>
            <div class="form-group m-label col-md-7">
              <input
                type="tel"
                class="form-control"
                v-model="selectedFields.phone"
                id="phone-number"
                :disabled="isLoading"
                required
                placeholder="Phone number"
              />
              <label for="phone-number">Phone number</label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Nav btn's -->
    <div class="row justify-content-center mb-5 mt-4">
      <div class="col-6 text-center">
        <button
          class="btn btn-primary btn-custom w-50 mr-5 prev"
          @click="prev"
          :disabled="step === 1 || step < 0 || isLoading"
        >
          <i class="fa fa-chevron-left mr-3"></i> Back
        </button>
      </div>
      <div class="col-6 text-center">
        <button
          v-if="step == 2"
          type="submit"
          form="add-for-job"
          class="btn btn-success btn-custom w-50 mr-2"
          :disabled="isNextDisabled"
          @click="saveEmployer"
        >
          Save
        </button>
        <button
          v-else
          type="submit"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-50"
          @click="next"
          :disabled="isNextDisabled"
        >
          Next
          <i class="fa fa-chevron-right ml-3"></i>
        </button>
      </div>
      <div v-if="isLoading" class="spinner-container">
        <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span>Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';

import Message from '../../AlertMessages/Message';
import { errorService } from '../../../services/errorService';

export default {
  components: {
    Message,
  },
  data: () => ({
    isNextDisabled: true,
    showModal: true,
    step: 1,
    isLoading: false,
    errorMessage: '',
    selectedFields: {
      name: '',
      orgo: '',
      countryName: '',
      countryId: '',
      cityId: '',
      postal: '',
      website: '',
      firstName: '',
      lastName: '',
      email: '',
      countryCode: '',
      phone: '',
      street: '',
    },
    selectedEmail: '',
    selectedCity: {},
    selectedCountry: {},
  }),
  validations: {
    selectedFields: {
      name: {
        required,
        minLength: minLength(3),
      },
      street: {
        required,
      },
      postal: {
        required,
      },
      countryName: {
        required,
      },
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
    },
    selectedCountry: { required },
    selectedCity: { required },
    selectedEmail: { required },
  },
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveAllCountries',
      'addEmployer',
      'retrieveCityByCountryId',
      'retrieveCitiesListByCountryId',
      'checkIfEmailExist',
    ]),
    addCountryCode(code) {
      this.selectedFields.countryCode = code.replace(/[0-9+]/g, '');
      this.selectedFields.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    /* setEmail($event) {
      this.selectedFields.email = $event.target.value.toLowerCase();
    }, */
    fetchCitiesByCountryId(e) {
      const countryID = e.id;
      this.retrieveCitiesListByCountryId({ id: countryID }).then(() => {
        this.selectedCity = {};
        this.changeDefaultCountry(e);
      });
    },
    fetchCitiesByCountryIdOnMount(e) {
      const countryID = e;
      this.retrieveCitiesListByCountryId({ id: countryID }).then(() => {
        this.selectedCity = {};
      });
    },

    changeDefaultCountry(e) {
      this.selectedFields.countryCode = e.name;
      this.selectedFields.phone = `${e.phone_code} `;
    },
    saveEmployer() {
      const {
        name,
        orgo,
        street,
        postal,
        website,
        firstName,
        lastName,
        title,
        countryCode,
        phone,
      } = this.selectedFields;

      this.addEmployer({
        name,
        registration_number: orgo,
        email: this.selectedEmail,
        country_id: this.selectedCountry.id,
        city_id: this.selectedCity.id,
        street,
        postal_code: postal,
        website: website,
        first_name: firstName,
        last_name: lastName,
        title: title,
        country_code: countryCode,
        phone_number: phone,
      })
        .then(() => {
          this.$emit('new-emp');
          this.$toasted.success(`You successfully added Employer ${name}.`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });

          /*       this.$router.go(); */
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    checkEmailExist($event) {
      this.checkIfEmailExist($event.target.value)
        .then(() => {
          if (this.getIsEmailExist) {
            this.errorMessage = 'Email Already Exist';
          }
        })
        .catch(() => {
          this.errorMessage = '';
        });
    },
    next() {
      this.step++;
    },
    prev() {
      this.step--;
    },
    stepValidator() {
      if (this.step === 1) {
        if (
          this.$v.selectedFields.name.$invalid === true ||
          this.$v.selectedFields.street.$invalid === true ||
          this.$v.selectedFields.postal.$invalid === true
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }

      if (this.step === 2) {
        if (
          this.$v.selectedFields.firstName.$invalid === true ||
          this.$v.selectedFields.lastName.$invalid === true ||
          this.$v.selectedEmail.$invalid === true
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }
    },
    setDefaultCountry() {
      this.selectedCountry = {
        id: 213,
        name: 'Sweden',
        part_of_eu: 1,
        phone_code: '+46',
        source: 'system',
      };
      this.fetchCitiesByCountryIdOnMount(213);
      this.selectedFields.countryCode = this.selectedCountry.name;
      this.selectedFields.phone = `${this.selectedCountry.phone_code} `;
    },
  },
  computed: {
    ...mapGetters([
      'getEmployersDropdown',
      'getAllCountries',
      'getCitiesByCountry',
      'getCitiesListByCountry',
      'getIsEmailExist',
    ]),
  },
  watch: {
    /* selectedFields: {
      handler(val) {
        localStorage.addEmployerCountryCode = val.countryCode;
        localStorage.addEmployerCountry = val.countryName;
      },
      deep: true,
    }, */
  },
  created() {
    this.retrieveAllCountries();
  },
  updated() {
    this.stepValidator();
  },
  mounted() {
    this.setDefaultCountry();

    /* if (localStorage.addEmployerCountryCode)
      this.selectedFields.countryCode = localStorage.addEmployerCountryCode;
    if (localStorage.addEmployerCountry)
      this.selectedFields.countryName = localStorage.addEmployerCountry; */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.editor {
  box-shadow: 0px 2px 3px #0000000d;
  /* border: 1px solid #d7dae2; */
  border-radius: 4px;
  opacity: 1;
}

.social-buttons a {
  font-size: 0.875rem;
  font-weight: 400;
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 4px;
}

.separator {
  position: relative;
  text-align: center;
  color: #b6b6b6;
  opacity: 0.8;

  span {
    display: inline-block;
    vertical-align: baseline;
    position: relative;
    padding: 0 20px;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 5.5rem;
      position: absolute;
      top: 0.73em;
      border-top: 1px solid #b6b6b6;
    }

    &:before {
      right: 100%;
    }

    &:after {
      left: 100%;
    }
  }
}

.form-group.required-fixed-right {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10.5px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-country {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 7px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-postal-code {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 24px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-city {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

/* MODAL */

/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}

/* END MODAL */

/* Pagination */
.paginate {
  display: flex;
}

.paginate .prev {
  background: linear-gradient(90deg, #122549, #203762);
  text-align: right;
  justify-content: flex-end;
}

.paginate .next,
.paginate .prev {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  width: 50%;
  padding: 0 2em;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  transition: padding 0.5s cubic-bezier(0.19, 1, 0.22, 1);
}

button {
  outline: 0;
}

/* .next i {
  margin-left: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .next:hover i {
  margin-left: 20px !important;
  transition: all 0.4s;
} */

/* .prev i {
  margin-right: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .prev:hover i {
  margin-right: 20px !important;
  transition: ease-in-out 0.4s;
} */

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media screen and (min-width: 40em) {
  .paginate .next,
  .paginate .prev {
    height: 118px;
    font-size: 32px;
  }
}

select,
input[type='number'],
input[type='text'],
input[type='search'] {
  height: 3rem;
  padding-top: 8px;
  line-height: 1.3;
}

.search-typehead {
  min-height: 3rem !important;
}

.add-job-comments {
  padding-top: 1.2rem;
}
</style>
